var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPhotoAlternate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 22.9844H17.0156L12.9844 18.0156L9.98438 22L8.01562 19L5.01562 22.9844ZM15.9844 15.0156H18.9844V22.9844C18.9844 23.5156 18.7812 23.9844 18.375 24.3906C18 24.7969 17.5469 25 17.0156 25H5.01562C4.48438 25 4.01562 24.7969 3.60938 24.3906C3.20312 23.9844 3 23.5156 3 22.9844V10.9844C3 10.4531 3.20312 10 3.60938 9.625C4.01562 9.21875 4.48438 9.01562 5.01562 9.01562H12.9844V12.0156H15.9844V15.0156ZM18.9844 10.9844V13.9844H17.0156V10.9844H14.0156V9.01562H17.0156V6.01562H18.9844V9.01562H21.9844V10.9844H18.9844Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoAlternate);
export default __webpack_public_path__ + "static/media/add_photo_alternate.1e1659402a9a7ec186c9ddabc79e5205.svg";
export { ForwardRef as ReactComponent };